import {
  ShiftsGroupEvent,
  timeStringFrom24HourTimeString,
} from '@nextforce/api'
import { Divider, makeStyles, Text } from '@rneui/themed'
import { t } from 'app/i18l'
import { font } from 'app/theme'
import React from 'react'
import { View } from 'react-native'

interface Props {
  event: ShiftsGroupEvent
  hideDivider?: boolean
  showAddedByNext?: boolean
}

export const EVENT_TIME_HEIGHT = 26

export function Time({ event, hideDivider, showAddedByNext }: Props) {
  const styles = useStyles()
  return (
    <View style={styles.container}>
      <View style={styles.innerContainer}>
        <Text style={styles.text}>
          {timeStringFrom24HourTimeString(event.time)}
        </Text>
        {showAddedByNext ? <Text>{t('addedByNext')}</Text> : null}
      </View>
      {!hideDivider ? <Divider style={styles.divider} /> : null}
    </View>
  )
}

const useStyles = makeStyles(theme => ({
  container: {
    height: EVENT_TIME_HEIGHT,
  },
  text: {
    fontSize: 13,
    fontFamily: font.bold,
    color: theme.colors?.black,
    marginHorizontal: 5,
    marginBottom: 2,
  },
  divider: {
    width: '100%',
  },
  innerContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
}))
